/* Same specs pin measurement and state transitions used by Simple. */
(() => {
 const root=document.querySelector('[data-ak-ath-product]'); if(!root)return;
 const desktop=matchMedia('(min-width:1201px)');
 const controller=new AbortController(); const signal=controller.signal;
 function syncAkSimpleNativeScrollport() {
   const main=document.getElementById('MainContent');
   if(desktop.matches){document.body.style.setProperty('overflow','visible','important');main?.style.setProperty('overflow','visible','important');}
   else{document.body.style.removeProperty('overflow');main?.style.removeProperty('overflow');}
 }
 syncAkSimpleNativeScrollport();
 desktop.addEventListener('change',syncAkSimpleNativeScrollport,{signal});

 let sessionPinFrame=0,sessionPinStart=0,sessionPinEnd=0,sessionHandoffStart=Infinity,sessionMenuPinStart=Infinity;
    function getAkStickyContentTop() {
        const rootStyle =
            getComputedStyle(root);

        const outerInset =
            parseFloat(
                rootStyle.getPropertyValue(
                    '--ak-flow-outer-inset'
                )
            ) || 15;

        const menuHeight =
            parseFloat(
                rootStyle.getPropertyValue(
                    '--ak-top-menu-height'
                )
            ) || 44;

        /* The live menu rect is transient during the first entrance: its
           containing frame moves into place before the first scroll. Using
           that rect made the initial sticky pass cache a top 44px too high,
           then jump once the menu settled. Sticky geometry belongs to the
           fixed frame, so derive it only from the frame inset + menu height. */
        return outerInset + menuHeight;
    }

    function getAkSession2Top() {
        /* Product specs stays in document flow. Only the copy/image panel
           pins, and its top border shares the menu's painted bottom pixel.
           This gives one continuous 1px seam instead of two adjacent
           borders, while the opaque panel closes off everything behind it. */
        return getAkStickyContentTop() - 1;
    }

    function getAkDesktopRoomHeight(shell, session) {
        if (session.classList.contains('ak-simple-session-2')) return session.offsetHeight;
        const image = session.querySelector('.ak-room-preview__room');
        if (!image?.naturalWidth || !image.naturalHeight) return session.offsetHeight;
        const style = getComputedStyle(session);
        const border = (parseFloat(style.borderTopWidth) || 0)
            + (parseFloat(style.borderBottomWidth) || 0);
        return shell.getBoundingClientRect().width * image.naturalHeight / image.naturalWidth + border;
    }

    function measureAkSession2Pin() {
        sessionPinFrame = 0;

        const story =
            document.querySelector(
                '[data-ak-session-story]'
            );

        const shell =
            story?.querySelector(
                '[data-ak-session-2-shell]'
            );

        const session =
            shell?.querySelector(
                '[data-ak-room-preview]'
            );

        if (!story || !shell || !session) return;

        if (!desktop.matches) {
            story.classList.remove('is-session-2-pinned');
            return;
        }

        const top = getAkSession2Top();
        const sessionHeight = desktop.matches
            ? getAkDesktopRoomHeight(shell, session)
            : session.offsetHeight;

        if (sessionHeight > 0) {
            shell.style.height =
                `${sessionHeight}px`;

            story.style.setProperty(
                '--ak-session-2-height',
                `${sessionHeight}px`
            );
        }

        const shellRect =
            shell.getBoundingClientRect();
        const visuals = document.querySelector('[data-ak-visuals-label]');
        const visualsGrid = document.querySelector('.ak-simple-mosaic__grid');
        const visualsRect = visuals?.getBoundingClientRect();
        const visualsGridRect = visualsGrid?.getBoundingClientRect();
        const purchaseBar = document.querySelector('.ak-ath-product__purchase');
        const purchaseRect = purchaseBar?.getBoundingClientRect();
        const stableScrollY = window.scrollY;
        const labelSlot = story.querySelector('.ak-simple-session-2__label-slot');
        const shellDocumentTop = stableScrollY + story.getBoundingClientRect().top
            + (labelSlot?.getBoundingClientRect().height || 0) - 1;
        const menuTop = getAkStickyContentTop() - 1;

        /* VISUALS is a static part of the gallery. When copy + image first
           become sticky, exactly half of the label is visible above the
           fixed purchase bar; the other half is already behind it. */
        const visualsHeight = visualsRect?.height || visuals?.offsetHeight || 0;
        const halfVisibleTop = purchaseRect?.height > 0
            ? purchaseRect.top - (visualsHeight / 2)
            : top + sessionHeight - (visualsHeight / 2);
        const mosaicFollowOffset =
            halfVisibleTop + visualsHeight - (top + sessionHeight);

        story.style.setProperty(
            '--ak-mosaic-follow-offset',
            `${Math.min(0, mosaicFollowOffset)}px`
        );

        /* The label has no independent entrance or transform. Its document
           position therefore comes directly from the gallery grid. */
        const visualsDocumentTop = visualsGridRect
            ? shellDocumentTop + sessionHeight + mosaicFollowOffset - visualsHeight
            : visualsRect
                ? window.scrollY + visualsRect.top
                : Infinity;

        const rootStyle = getComputedStyle(root);
        const heading = root.querySelector('.ak-session-one-heading');
        const headingHeight = heading?.getBoundingClientRect().height ||
            parseFloat(rootStyle.getPropertyValue('--ak-session-one-heading-height')) ||
            0;
        const sessionOnePinTop = parseFloat(
            rootStyle.getPropertyValue('--ak-simple-session-one-pin-top')
        );
        /* Use the exact painted bottom rule of the pinned product heading
           for every Simple layout. The former 45vh estimate on triptych
           products meant VISUALS and the title could never share one line. */
        const headingPinTop = root.classList.contains('ak-simple-session-one-is-wide')
            ? getAkStickyContentTop()
            : Number.isFinite(sessionOnePinTop)
                ? sessionOnePinTop
                : top - headingHeight + 1;
        const handoffViewportTop = headingPinTop + headingHeight - 1;

        const nativeVisualsRect = visuals?.getBoundingClientRect();
        const nativeVisualsDocumentTop = nativeVisualsRect
            ? stableScrollY + nativeVisualsRect.top
            : visualsDocumentTop;

        sessionHandoffStart = Number.isFinite(nativeVisualsDocumentTop)
            ? nativeVisualsDocumentTop - handoffViewportTop
            : Infinity;
        sessionMenuPinStart = sessionHandoffStart + Math.max(0, top - menuTop);

        story.style.setProperty(
            '--ak-session-2-top',
            `${top}px`
        );

        story.style.setProperty(
            '--ak-session-2-menu-top',
            `${menuTop}px`
        );

        story.style.setProperty(
            '--ak-session-2-release-top',
            `${sessionHandoffStart + top - shellDocumentTop}px`
        );

        story.style.setProperty(
            '--ak-session-2-left',
            `${shellRect.left}px`
        );

        story.style.setProperty(
            '--ak-session-2-width',
            `${shellRect.width}px`
        );

        const storyRect =
            story.getBoundingClientRect();

        /* Product specs scrolls away normally. Pin only the copy + image
           when its own top border reaches the shared pixel beneath the
           fixed menu. */
        sessionPinStart = shellDocumentTop - top;

        sessionPinEnd =
            stableScrollY + storyRect.bottom - top;

        syncAkSession2Pin();
    }

    function scheduleAkSession2Pin(event) {
        if (
            desktop.matches &&
            ['ak-product-grid-synced', 'ak-bottom-nav-grid-synced'].includes(event?.type) &&
            document.querySelector('[data-ak-session-story]')?.classList.contains('is-session-2-pinned')
        ) return;

        if (!sessionPinFrame) {
            sessionPinFrame = requestAnimationFrame(measureAkSession2Pin);
        }
    }

    function syncAkSession2Pin() {
        const story =
            document.querySelector(
                '[data-ak-session-story]'
            );

        if (!story) return;

        if (!desktop.matches) {
            story.querySelector('[data-ak-details-label]')?.style.removeProperty('clip-path');
            story.classList.remove(
                'is-session-2-pinned',
                'is-session-2-menu-pinned',
                'is-session-2-returning',
                'is-session-2-released'
            );
            root.classList.remove('ak-simple-story-heading-mask');
            return;
        }

        const stableScrollY = window.scrollY;
        const detailsLabel = story.querySelector('[data-ak-details-label]');
        const inPinRange =
            stableScrollY >= sessionPinStart &&
            stableScrollY < sessionPinEnd;
        const liveSessionTop = getAkSession2Top();
        const shouldPin = inPinRange;

        story.style.setProperty(
            '--ak-session-2-top',
            `${liveSessionTop}px`
        );

        detailsLabel?.style.removeProperty('clip-path');
        root.classList.remove('ak-simple-story-heading-mask');

        story.classList.toggle(
            'is-session-2-menu-pinned',
            false
        );

        story.classList.toggle(
            'is-session-2-returning',
            false
        );

        story.classList.toggle(
            'is-session-2-released',
            false
        );

        story.classList.toggle(
            'is-session-2-pinned',
            shouldPin
        );

    }

    function initAkSession2Pin() {
        const roomImage =
            document.querySelector(
                '[data-ak-session-2-shell] .ak-room-preview__room'
            );

        if (
            roomImage &&
            !roomImage.complete
        ) {
            roomImage.addEventListener(
                'load',
                scheduleAkSession2Pin,
                {
                    once: true,
                    signal
                }
            );
        }

        scheduleAkSession2Pin();
    }


 function schedule(){scheduleAkSession2Pin();}
 window.addEventListener('scroll',syncAkSession2Pin,{passive:true});
 ['resize','load','ak:boot-revealed','ak:global-frame-ready','ak-product-grid-synced','ak-bottom-nav-grid-synced'].forEach(name=>window.addEventListener(name,schedule));
 document.fonts?.ready.then(schedule);
 initAkSession2Pin();
 const story=document.querySelector('[data-ak-session-story]');
 new ResizeObserver(schedule).observe(story);
})();

(function () {
    const section = document.querySelector('.ak-session-6');
    const visibleSiteRail = document.querySelector('.ak-site-frame-rail--left');
    const useVisibleSiteRail = Boolean(
        visibleSiteRail && document.body.classList.contains('ak-site-frame-enabled')
    );
    const hatch = useVisibleSiteRail
        ? visibleSiteRail.querySelector('.ak-site-frame-rail__hatch')
        : document.querySelector(
            '.ak-product-left-edge-rail .ak-product-edge-hatch'
        );

    if (!section || !hatch) return;

    let relatedScrollGeometry = null;
    function syncRelatedScrollPosition() {
        if (!relatedScrollGeometry || innerWidth < 1201) return;
        const naturalTop = relatedScrollGeometry.documentTop - window.scrollY;
        const shift = naturalTop <= relatedScrollGeometry.headingTop + 2
            ? relatedScrollGeometry.headingTop - naturalTop : 0;
        const next = shift.toFixed(3) + 'px';
        if (section.style.getPropertyValue('--ak-related-section-shift') !== next) {
            section.style.setProperty('--ak-related-section-shift', next);
            const ratio = Math.max(1, window.devicePixelRatio || 1);
            const top = section.getBoundingClientRect().top;
            const target = Math.abs(top - relatedScrollGeometry.headingTop) < 2
                ? relatedScrollGeometry.headingTop : top;
            section.style.setProperty('--ak-related-top-rule-offset',
                `${Math.floor(target * ratio) / ratio - top}px`);
        }
    }

    function fitRelatedPosters() {
        if (!window.matchMedia('(min-width: 1201px)').matches) return;

        const productSplit = document.querySelector('[data-ak-ath-product]');
        if (!productSplit) return;

        /* The rail spans the document, so reading its hatch height while this
           section changes document height creates a feedback loop on reload.
           Derive the visible hatch from the fixed desktop frame instead. */
        const splitStyle = getComputedStyle(productSplit);
        const px = (name, fallback) => {
            const value = Number.parseFloat(splitStyle.getPropertyValue(name));
            return Number.isFinite(value) ? value : fallback;
        };
        const outerInset = px('--ak-flow-outer-inset', 15);
        const topMenuHeight = px('--ak-top-menu-height', 44);
        const bottomMenuHeight = px('--ak-bottom-menu-height', 44);
        const topGrid = useVisibleSiteRail
            ? visibleSiteRail.querySelector('.ak-site-frame-rail__grid--top')
            : document.querySelector(
                '.ak-product-left-edge-rail .ak-product-edge-grid-top'
            );
        const bottomGrid = useVisibleSiteRail
            ? visibleSiteRail.querySelector('.ak-site-frame-rail__grid--bottom')
            : document.querySelector(
                '.ak-product-left-edge-rail .ak-product-edge-grid-bottom'
            );
        if (!topGrid || !bottomGrid) return;
        const height =
            window.innerHeight
            - outerInset
            - topMenuHeight
            - (outerInset + bottomMenuHeight - 1)
            - topGrid.getBoundingClientRect().height
            - bottomGrid.getBoundingClientRect().height;
        if (height <= 0) return;

        section.style.setProperty(
            '--ak-related-visual-height',
            `${height}px`
        );

        const relatedColumnWidth =
            section.getBoundingClientRect().width / 3;
        const relatedFrameSize =
            Math.min(relatedColumnWidth, height) * 0.8;

        section.style.setProperty(
            '--ak-related-frame-size',
            `${relatedFrameSize.toFixed(3)}px`
        );

        section.style.setProperty('--ak-related-portrait-ratio', String(102 / 142));

        const portraitFrame = section.querySelector(
            '.ak-session-6__card:not([hidden]) '
            + '.ak-simple-related-image-frame[data-ak-related-format="portrait"]'
        ) || section.querySelector(
            '.ak-simple-related-image-frame[data-ak-related-format="portrait"]'
        );

        if (portraitFrame) {
            const portraitAspectRatio = getComputedStyle(portraitFrame)
                .getPropertyValue('--ak-related-aspect-ratio')
                .trim();
            const [portraitWidth, portraitHeight = 1] =
                portraitAspectRatio.split('/').map(Number);
            const portraitRatio = portraitWidth / portraitHeight;

            if (Number.isFinite(portraitRatio) && portraitRatio > 0) {
                section.style.setProperty('--ak-related-portrait-ratio', String(portraitRatio));
                section.style.setProperty(
                    '--ak-related-square-art-width',
                    `${(75 * portraitRatio).toFixed(3)}%`
                );
            }
        }

        const productOptions = document.querySelector(
            '.ak-product-split .ak-desktop-options'
        );
        const productOptionsWidth =
            productOptions?.getBoundingClientRect().width || 0;

        if (productOptionsWidth > 0) {
            section.style.setProperty(
                '--ak-related-frame-width',
                `${productOptionsWidth * (2 / 3)}px`
            );
        }

        const relatedTitle = section.querySelector('.ak-session-6__title');
        const railCellSelector = useVisibleSiteRail
            ? '.ak-site-frame-rail__cell'
            : '.ak-product-edge-grid-cell';
        const topCells = topGrid
            ? [...topGrid.querySelectorAll(railCellSelector)]
            : [];
        const bottomCells = bottomGrid
            ? [...bottomGrid.querySelectorAll(railCellSelector)]
            : [];
        /* Use the third row of the rail; its bottom is the fourth painted
           line when the grid's top line is included. */
        const thirdTopRowCell = topCells[useVisibleSiteRail ? 8 : 6];
        const fourthBottomRowCell = bottomCells[9];

        if (relatedTitle && thirdTopRowCell && fourthBottomRowCell) {
            const headingTopBorder = Number.parseFloat(
                getComputedStyle(thirdTopRowCell).borderBottomWidth
            ) || 1;
            const topGridBottomBorder = Number.parseFloat(
                getComputedStyle(topGrid).borderBottomWidth
            ) || 1;
            const sectionTopBorder = Number.parseFloat(
                getComputedStyle(section).borderTopWidth
            ) || 1;
            const headingTop =
                thirdTopRowCell.getBoundingClientRect().bottom
                - headingTopBorder;
            const headingBottom =
                topGrid.getBoundingClientRect().bottom
                - topGridBottomBorder;
            const headingHeight =
                headingBottom - headingTop - sectionTopBorder;
            const captionBottomBorder = Number.parseFloat(
                getComputedStyle(fourthBottomRowCell).borderBottomWidth
            ) || 1;
            const fallbackCaptionHeight =
                fourthBottomRowCell.getBoundingClientRect().bottom
                - captionBottomBorder
                - bottomGrid.getBoundingClientRect().top;

            section.style.setProperty(
                '--ak-related-heading-height',
                `${Math.max(0, headingHeight).toFixed(3)}px`
            );

            const currentSectionShift = Number.parseFloat(
                section.style.getPropertyValue('--ak-related-section-shift')
            ) || 0;
            const naturalSectionTop =
                section.getBoundingClientRect().top - currentSectionShift;
            relatedScrollGeometry = {documentTop: naturalSectionTop + window.scrollY, headingTop};
            const shouldBindToFrame =
                naturalSectionTop <= headingTop + 2;
            const nextSectionShift = shouldBindToFrame
                ? headingTop - naturalSectionTop
                : 0;

            if (Math.abs(nextSectionShift - currentSectionShift) > 0.01) {
                section.style.setProperty(
                    '--ak-related-section-shift',
                    `${nextSectionShift.toFixed(3)}px`
                );
            }

            section.style.setProperty(
                '--ak-title-box-height',
                `${fallbackCaptionHeight.toFixed(3)}px`
            );

            const firstVisibleName = [
                ...section.querySelectorAll('.ak-session-6__card:not([hidden]) .ak-session-6__name')
            ].find(name => name.getBoundingClientRect().height > 0);

            if (firstVisibleName) {
                const captionHeight =
                    fourthBottomRowCell.getBoundingClientRect().bottom
                    - captionBottomBorder
                    - firstVisibleName.getBoundingClientRect().top;
                const isActiveFrameMeasurement =
                    Math.abs(captionHeight - fallbackCaptionHeight) <= 2;

                if (isActiveFrameMeasurement) {
                    section.style.setProperty(
                        '--ak-title-box-height',
                        `${captionHeight.toFixed(3)}px`
                    );
                }
            }

            // Paint the top rule on the same physical-pixel boundary as
            // the rail. Fractional layout positions can otherwise round the
            // two adjoining one-pixel borders in opposite directions.
            const pixelRatio = Math.max(1, window.devicePixelRatio || 1);
            const sectionTop = section.getBoundingClientRect().top;
            const ruleTop = Math.abs(sectionTop - headingTop) < 2
                ? headingTop : sectionTop;
            section.style.setProperty(
                '--ak-related-top-rule-offset',
                `${Math.floor(ruleTop * pixelRatio) / pixelRatio - sectionTop}px`
            );
            section.style.setProperty('--ak-related-grid-pixel-phase', '0px');
        }

        section.querySelectorAll('.ak-session-6__card').forEach(card => {
            card.style.removeProperty('--ak-name-divider-left');
        });

        const visibleCards = [
            ...section.querySelectorAll(
                '.ak-session-6__card:not([hidden])'
            )
        ].sort((cardA, cardB) => {
            const orderA = Number.parseInt(cardA.style.order, 10) || 0;
            const orderB = Number.parseInt(cardB.style.order, 10) || 0;
            return orderA - orderB;
        });
        const centerCard =
            visibleCards[Math.floor(visibleCards.length / 2)];
        const centerName =
            centerCard?.querySelector('.ak-session-6__name');

        if (centerName) {
            const sectionBox = section.getBoundingClientRect();
            const nameBox = centerName.getBoundingClientRect();
            const targetX = sectionBox.left + (sectionBox.width / 2);

            centerCard.style.setProperty(
                '--ak-name-divider-left',
                `${targetX - nameBox.left}px`
            );
        }

        let shortSide = Infinity;

        section.querySelectorAll(
            '.ak-session-6__card:not([hidden])'
        ).forEach(card => {
            const visual = card.querySelector('.ak-session-6__visual');
            const art = card.querySelector('[data-ak-room-display="card"]');
            if (!visual || !art) return;

            const style = getComputedStyle(visual);
            const width = visual.clientWidth
                - parseFloat(style.paddingLeft)
                - parseFloat(style.paddingRight);
            const availableHeight = visual.clientHeight
                - parseFloat(style.paddingTop)
                - parseFloat(style.paddingBottom);

            const parts = getComputedStyle(art).aspectRatio
                .split('/').map(Number);
            const ratio = parts[0] / (parts[1] || 1);
            if (!Number.isFinite(ratio) || ratio <= 0) return;

            const limit = ratio >= 1
                ? Math.min(availableHeight, width / ratio)
                : Math.min(width, availableHeight * ratio);

            shortSide = Math.min(shortSide, limit);
        });

        if (Number.isFinite(shortSide) && shortSide > 0) {
            section.style.setProperty(
                '--ak-related-short-side',
                `${shortSide * (2 / 3)}px`
            );
        }

        window.dispatchEvent(new CustomEvent('ak-related-geometry-synced'));
    }

    let alignmentFrame = 0;
    const scheduleRelatedAlignment = () => {
        cancelAnimationFrame(alignmentFrame);
        alignmentFrame = requestAnimationFrame(() => {
            requestAnimationFrame(fitRelatedPosters);
        });
    };

    const observer = new ResizeObserver(scheduleRelatedAlignment);
    observer.observe(hatch);

    const pageSizeObserver = new ResizeObserver(scheduleRelatedAlignment);
    pageSizeObserver.observe(document.body);

    const visibilityObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
            scheduleRelatedAlignment();
        }
    });
    visibilityObserver.observe(section);

    const grid = section.querySelector('.ak-session-6__grid');
    if (grid) {
        new MutationObserver(scheduleRelatedAlignment).observe(grid, {
            subtree: true,
            attributes: true,
            attributeFilter: ['hidden', 'class']
        });
    }

    window.addEventListener('resize', scheduleRelatedAlignment);
    window.addEventListener('scroll', syncRelatedScrollPosition, {
        passive: true
    });
    window.addEventListener('load', scheduleRelatedAlignment);
    window.addEventListener('pageshow', scheduleRelatedAlignment);
    section.addEventListener('load', scheduleRelatedAlignment, true);
    document.fonts?.ready.then(scheduleRelatedAlignment);

    [0, 100, 400, 1000].forEach(delay => {
        window.setTimeout(scheduleRelatedAlignment, delay);
    });
})();
/* Use Simple's exact visible-text fitting for the Other Vibes heading. */
(function () {
    document.querySelectorAll('.ak-session-6__title').forEach(title => {
        if (title.querySelector('.ak-title-fit')) return;

        const text = document.createElement('span');
        text.className = 'ak-title-fit';
        text.textContent = window.matchMedia('(max-width: 1200px)').matches
            ? title.dataset.akTitleMobile || title.textContent.trim()
            : title.dataset.akTitleDesktop || title.textContent.trim();
        title.replaceChildren(text);

        function fit() {
            const responsiveText = window.matchMedia('(max-width: 1200px)').matches
                ? title.dataset.akTitleMobile
                : title.dataset.akTitleDesktop;
            if (responsiveText && text.textContent !== responsiveText) {
                text.textContent = responsiveText;
            }

            const width = title.clientWidth;
            const height = title.clientHeight;
            if (width <= 0 || height <= 0) return;

            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            if (!context) return;

            title.style.setProperty('--ak-heading-padding', '0px');
            text.style.transform = 'none';

            const measureVisibleText = (fontSize, content = text.textContent) => {
                title.style.setProperty('font-size', `${fontSize}px`, 'important');
                const style = getComputedStyle(title);
                context.font = `${style.fontStyle} ${style.fontWeight} ${fontSize}px ${style.fontFamily}`;

                const metrics = context.measureText(content);
                const spacing = parseFloat(style.letterSpacing) || 0;
                const spacingWidth = spacing * Math.max(0, content.length - 1);

                return {
                    width: Math.max(
                        1,
                        (metrics.actualBoundingBoxLeft || 0)
                            + (metrics.actualBoundingBoxRight || metrics.width)
                            + spacingWidth
                    ),
                    height: Math.max(
                        1,
                        (metrics.actualBoundingBoxAscent || fontSize)
                            + (metrics.actualBoundingBoxDescent || 0)
                    ),
                    metrics
                };
            };

            const referenceSize = 100;
            const reference = measureVisibleText(referenceSize, window.matchMedia('(max-width: 1200px)').matches
                ? text.textContent : 'OTHER VIBES FOR YOUR INTERIOR');
            const widthRate = reference.width / referenceSize;
            const heightRate = reference.height / referenceSize;
            /* Desktop side squares match the heading height, followed by 44px text gaps. */
            const mobile = window.matchMedia('(max-width: 1200px)').matches;
            const targetWidth = mobile ? width : Math.max(1, width - 2 * (height + 44));
            const size = Math.max(
                1,
                Math.min(
                    targetWidth / widthRate,
                    (height - 2) / heightRate
                )
            );

            const finalMeasurement = measureVisibleText(size);
            const equalPadding = Math.max(
                0,
                Math.min(
                    (width - finalMeasurement.width) / 2,
                    (height - finalMeasurement.height) / 2
                )
            );

            title.style.setProperty('--ak-heading-padding', `${equalPadding}px`);

            const range = document.createRange();
            range.selectNodeContents(text);
            const rangeRect = range.getBoundingClientRect();
            const titleRect = title.getBoundingClientRect();
            const metrics = finalMeasurement.metrics;
            const fontBoxAscent = metrics.fontBoundingBoxAscent;
            const fontBoxDescent = metrics.fontBoundingBoxDescent;

            let verticalShift = 0;
            if (
                Number.isFinite(fontBoxAscent)
                && Number.isFinite(fontBoxDescent)
                && fontBoxAscent + fontBoxDescent > 0
            ) {
                const fontBoxScale = rangeRect.height / (fontBoxAscent + fontBoxDescent);
                const visibleTop = rangeRect.top
                    + (fontBoxAscent - metrics.actualBoundingBoxAscent) * fontBoxScale;
                const visibleBottom = rangeRect.bottom
                    - (fontBoxDescent - metrics.actualBoundingBoxDescent) * fontBoxScale;
                const topGap = visibleTop - titleRect.top;
                const bottomGap = titleRect.bottom - visibleBottom;
                verticalShift = (bottomGap - topGap) / 2;
            }

            const horizontalShift = mobile ? 0 : titleRect.left + width / 2
                - (rangeRect.left - (metrics.actualBoundingBoxLeft || 0) + finalMeasurement.width / 2);
            text.style.transform = `translate(${horizontalShift}px, ${verticalShift}px)`;
        }

        let frame = 0;
        const schedule = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(fit);
        };

        new ResizeObserver(schedule).observe(title);

        new MutationObserver(schedule).observe(text, {
            childList: true, characterData: true, subtree: true
        });

        document.fonts.ready.then(schedule);
        window.addEventListener('ak-related-geometry-synced', schedule);
        schedule();
    });
})();
